/* eslint no-irregular-whitespace: 0 */

const PlusFaq = [
  {
    title: 'Trending Topics',
    content: [
      {
        question: 'What is Vuse Plus and how does it work?',
        response: `
      <p>Vuse Plus is a rewards program that gives&nbsp;<a href="http://vuse.com">vuse.com</a>&nbsp;customers monthly vaping deals and special offers.</p>
      <p>Anyone who has a vuse.com account will start receiving these benefits when they spend $100 or more on vuse.com</p>
      <p>There are three tiers to reach as a Vuse Plus member: </p>
      <p>Silver status &ndash; $100 minimum lifetime spend<br />Gold status - $250 minimum lifetime spend<br />Platinum status - $400 minimum lifetime spend</p>
    `
      },
      {
        question: 'What does a lifetime spend mean?',
        response: `It’s the total amount of dollars you’ve spent on vuse.com since you created an account.`
      },
      {
        question: 'How do I sign up for Vuse Plus?',
        response: `
      <p>Make sure you have signed-up for a vuse.com account.</p>
      <p>Anyone who has a vuse.com account will start receiving deals and offers when they reach a lifetime spend of $100 or more on vuse.com and subscribed to our Vuse newsletter.</p>
    `
      }
    ]
  },
  {
    title: 'Eligibility',
    content: [
      {
        question: 'What are the eligibility requirements for Vuse Plus?',
        response: `
      <ul>
        <li>Anyone who has a vuse.com account can be eligible for Vuse Plus.</li>
      </ul>
      <ul>
        <li>There are two easy steps to qualify for the first tier: </li>
        <ul>
          <li>Subscribe to our newsletter</li>
          <li>Reach a lifetime spend of $100</li>
        </ul>
      </ul>
      <ul>
        <li>To keep your Vuse Plus account activated, make at least one purchase every month on vuse.com and stay subscribed to our Vuse newsletter. </li>
      </ul>
    `
      },
      {
        question: 'What is the minimum spend when I place my monthly qualifying order?',
        response: `There is no minimum spend, and you also don't need to buy any specific products. Say HOORAY to that!`
      },
      {
        question: 'Am I eligible for other vuse.com vape discounts and promotions?',
        response: `Yes, all regular promotions are still available to you but only one discount code can be applied per vuse.com order.`
      },
      {
        question: 'Does Vuse Plus have an expiry date?',
        response: `
          <p>There is no expiry date on your status but in the event Vuse Plus rewards program needs to be shut down indefinitely, your benefits associated with the tier-level you have reached will no longer be available.</p>
          <p>See <a href="https://www.vuse.com/pages/terms-conditions">terms and conditions</a> for more information.</p>
        `
      }
    ]
  },
  {
    title: 'Rewards',
    content: [
      {
        question: 'What are the vape deals and offers offered to Vuse Plus members?',
        response: `
      <p>The vape deals are based on which tier you qualify for. Here’s descriptions of tier benefits:</p>
      <p><strong>Silver<br /></strong>Reach a total lifetime spend of $100 or more </p>
      <ul>
        <li>15% discount code every month </li>
        <li>Free shipping on all orders</li>
        <li>Birthday gift</li>
      </ul>
      <p><strong>Gold<br /></strong>Reach a total lifetime spend of $250 or more and receive:</p>
      <ul>
        <li>20% discount code every month </li>
        <li>Free shipping on all orders</li>
        <li>Birthday gift</li>
      </ul>
      <p><strong>Platinum<br /></strong>Reach a total lifetime spend of $400 or more </p>
      <ul>
        <li>2 x 25% discount codes every month</li>
        <li>Free express shipping on all orders</li>
        <li>Early access to new flavours and devices</li>
      </ul>
    `
      },
      {
        question: 'How can I redeem my offers and deals?',
        response: `
      <p>Log into your vuse.com account and check your Rewards tab to view available offers and deals.</p>
      <p>The offers and deals listed will explain how to apply them to your next order.</p>
      <p>You can also check for newsletter updates in your email inbox.</p>
    `
      },
      {
        question: 'When do offers and deals expire?',
        response: `
      <p>Offers and deals for each calendar month expire at the end of that stated month.</p>
      <p>At the start of the next month, you will receive the available offers and deals associated to your status at that time.</p>
    `
      },
      {
        question: 'Does Vuse Plus include free shipping?',
        response: `
      <p>Silver and Gold status receives free regular shipping on all orders.</p>
      <p>Platinum status receives free express shipping on all orders.</p>
    `
      },
      {
        question: 'Can any of the Vuse Plus offers and deals be applied on purchases to other websites?',
        response: `The Vuse Plus rewards program is exclusive to vuse.com.`
      },
      {
        question: 'Can any of the Vuse Plus offers and deals be used at stores? ',
        response: `The Vuse Plus rewards program is exclusive to vuse.com.`
      },
      {
        question: 'How does the early access to products and flavours work?',
        response: `Once you reach Gold status (spend $250 or more) or Platinum status (spend $400 or more) and have an active Vuse Plus account, your vuse.com Rewards tab on your account page will display what products or flavours are available for you. You will also receive a notification via email newsletter when the offer is active.`
      },
      {
        question: 'How do I apply my monthly coupon code available to my current status?',
        response: `Copy and paste the discount code from your Rewards tab or email newsletter into the discount field at the check-out on vuse.com.`
      },
      {
        question:
          'What if my Vuse Plus discount code or any of the other offers for the calendar month do not doesn’t work?',
        response: `
      <p>Contact us at <a href="tel:1-844-746-8973">1-844-746-8973</a> or send an email to <a href="mailto:support@batsupport.zendesk.com">support@batsupport.zendesk.com</a> OR <a href="mailto:support@batsupport.zendesk.com">support@batsupport.zendesk.com</a>.</p>
      <p>The Vuse Care team operate within the hours of 8 am to 10 pm EST Monday to Friday excluding Bank Holidays.</p>
    `
      },
      {
        question: 'How do I claim my birthday reward?',
        response: `
      <p>All Vuse+ members receive a unique birthday coupon code on the 1st of their birthday calendar month (e.g. if your birthday falls on July 12th, you’ll receive your reward on July 1st). Birthday coupon codes will appear in the rewards tab on your vuse.com account page.</p>
      <p>To be eligible to receive a birthday reward, you must have active Vuse+ member status on the 1st of your birthday month.</p>
      <p>Birthday coupon codes are for one time use and can be applied at checkout on any vuse.com order. Your birthday coupon code will be valid for 30 days from its date of issue.</p>
    `
      }
    ]
  },
  {
    title: 'Status',
    content: [
      {
        question: 'How do I know my status?',
        response: `
      <p>There are three status tiers &ndash; Silver, Gold and Platinum.</p>
      <p>Simply log into your vuse.com account, and you'll see your status alongside all active deals and offers in the Rewards tab of your vuse.com account page. </p>
      <p>If you have not yet reached the first tier, the Rewards tab will tell you the next steps to complete. </p>
    `
      },
      {
        question: 'How do I move to the next tier?',
        response: `
      <p>You will automatically move up to the next tier when you reach the applicable lifetime spend on vuse.com. </p>
      <p>To move from Silver to Gold, reach a $250 minimum lifetime spend. </p>
      <p>To move from Gold to Platinum, reach a $400 minimum lifetime spend. </p>
    `
      },
      {
        question: 'Can my status be downgraded?',
        response: `
      <p>No, but you must make one purchase per month to keep your status active and subscribed to the newsletter. </p>
      <p>For example, once you reach $400 minimum spend, you are eligible for Platinum status. You will keep your Platinum status active as long as you make one purchase per month (no minimum spend required). </p>
      <p>If you do not make one purchase per month or choose to unsubscribe from receiving newsletters, your Vuse Plus account will be deactivated. A deactivated account will not receive offers associated with the current tier level. </p>
      <p>To re-activate, make a purchase when logged into your vuse.com account.</p>
    `
      },
      {
        question: 'What comes after Platinum?',
        response: `
      <p>You've reached our highest tier and receive the most deals and offers! Keep receiving Platinum status deals and offers by making one purchase per month (no minimum spend!).</p>
    `
      },
      {
        question: 'Can I share my status benefits with friends or family?',
        response: `
      <p>All the Vuse Plus deals and offers available to you are associated with your total lifetime spend on vuse.com. You cannot share any of these benefits with other vuse.com customers.</p>
    `
      }
    ]
  }
]

export default PlusFaq
